import { Inject, Injectable } from '@angular/core';
import {
  CheckboxFilterControl,
  FilterGroup,
  SearchFilterControl,
  SearchSelectFilterControl,
} from '@vendasta/va-filter2';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SenderTag } from '../manage-tags/tag-toggle/tag-toggle.component';

export const SENDER_TAGS_TOKEN = 'com.vendasta.partner_center.campaigns.table_filter.sender_tags';

@Injectable()
export class MyCampaignsTableFilterService {
  filters: FilterGroup = new FilterGroup('my-campaigns-table');

  constructor(@Inject(SENDER_TAGS_TOKEN) senderTags$: Observable<SenderTag[]>) {
    this.filters
      .addToolbarSection(new SearchFilterControl('search', 'Search Campaigns'))
      .addSection('Tags', [
        new SearchSelectFilterControl('tag', 'Tag', this.tagFilterOptions(senderTags$), null, {
          searchDisplay: (v: SenderTag) => v?.tagName,
          appliedValueMapper: (name: string, value: SenderTag) => {
            const uppercaseName = name.charAt(0).toUpperCase() + name.slice(1);
            return {
              name: name,
              value: value,
              label: value ? `${uppercaseName}: ${value.tagName}` : null,
            };
          },
        }),
      ])
      .addSection('Status', [
        new CheckboxFilterControl('Published', 'Published', true),
        new CheckboxFilterControl('Draft', 'Draft', true),
        new CheckboxFilterControl('Ongoing', 'Ongoing', true),
        new CheckboxFilterControl('Archived', 'Archived', false),
      ]);
  }

  tagFilterOptions(senderTags$: Observable<SenderTag[]>): Observable<Map<string, SenderTag>> {
    return senderTags$.pipe(
      map((st) => {
        const tagsMap = new Map<string, SenderTag>();
        tagsMap.set('All tags', null);
        st.forEach((t) => tagsMap.set(t.tagName, t));
        return tagsMap;
      }),
    );
  }
}
